export const DEFAULT_SIGN_UP_USER_NAME = 'User';

const BACKEND_SIGN_UP_NAME_PATTERN =
  /^(?![\s\S]*[^\w -]+)(?!.*[0-9])[\s\S]*?$/im;

export const getBackendSafeSignUpName = (name: string): string => {
  const trimmedName = name.trim();

  return trimmedName && BACKEND_SIGN_UP_NAME_PATTERN.test(trimmedName)
    ? trimmedName
    : DEFAULT_SIGN_UP_USER_NAME;
};
